export default (mappings) => (name) => mappings[name];
